import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { YourbetMiniBetSlip } from "./YourbetMiniBetSlip";
import { YourbetMiniBetSlipData } from "./data";
import { Parser } from "../../parser";
import { Retriever } from "../../retriever";
let _localMOCKTYPE;
let YourBetDataMock;
if (process.env.NODE_ENV === "development") {
    _localMOCKTYPE = require("../../mocks");
    YourBetDataMock = _localMOCKTYPE.YourBetDataMock;
}
export class YourbetMiniBetSlipRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {},
        betSlipUtil: {},
        oddsUtil: {},
        facade: {},
        gameStatus: {},
        timeControl: {},
        panelId: "",
        storageUtils: {},
        userInfo: {}
    }) {
        super(domId, options);
        if (process.env.NODE_ENV === "development") {
            // setup dictionary for debug build
            this.options.dict = BaseDict;
            // setup data mocks for debug build
            this.dataProvider = new YourbetMiniBetSlipData(new Parser(new Retriever(window["sbMsgBus"])), this.options.dict);
            //export data store to window for debug purposes
            window["YourbetMiniBetSlipDATA"] = this.dataProvider;
            window["YourbetMock"] = new YourBetDataMock(window["sbMsgBus"]);
            window["YourbetMock"].activate();
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            this.dataProvider = new YourbetMiniBetSlipData(new Parser(new Retriever(options.dataProvider)), this.options.dict);
        }
    }
    beforeActivate() {
        this.dataProvider.activate();
        return super.beforeActivate();
    }
    activate() {
        return super.activate(React.createElement(YourbetMiniBetSlip, { dataProvider: this.dataProvider, dict: this.options.dict, stakeInputType: this.options.cms.stakeInputType }));
    }
}
window["YourbetMiniBetSlip"] = YourbetMiniBetSlipRoot;
broadcastBlockLoad("YourbetMiniBetSlip");
//# sourceMappingURL=index.js.map